import { FieldArray } from "formik";
import { AccordionBody, AccordionHeader, AccordionItem } from "../../Accordion";
import RadioCard from "../../RadioCard";
import ValidatedField from "../../form/ValidatedField";
import IconDelete from "../../icons/IconDelete";
import { TableNumbers } from "../../layouts/TableNumbers";
import {
  RevisorsSectionProps,
  scrollToRefIfNotInView,
} from "../RevisorsErklaering";
import { isArray } from "lodash";
import { guid } from "../../../util/string";
import { FieldWithLabel } from "../../form/FieldWithLabel";

export default function RevisorsHandling13(props: RevisorsSectionProps) {
  const { locked, isCompleteHelpers, formikProps, refs, texts } = props;
  const { revisors_handling_13 } = texts;
  const { values, errors, touched } = formikProps;
  return (
    <AccordionItem value="Handling13">
      <AccordionHeader
        sectionStarted={!!values.revisors_handling_13_question}
        sectionComplete={isCompleteHelpers.revisors_handling_13_complete}
        ref={refs.handling_13_ref}
        onClick={() => {
          scrollToRefIfNotInView(refs.handling_12_ref);
        }}
      >
        {revisors_handling_13.title}
      </AccordionHeader>
      <AccordionBody>
        <fieldset disabled={locked}>
          <div className="h5 fw-normal mb-4 lh-base">
            {revisors_handling_13.description}
            <div className="row align-items-center">
              <label
                className="form-label col-auto"
                htmlFor={
                  revisors_handling_13
                    .revisors_handling_13_antal_transaktioner_udvalgt_som_stikproeve
                    .id
                }
              >
                {
                  revisors_handling_13
                    .revisors_handling_13_antal_transaktioner_udvalgt_som_stikproeve
                    .label
                }
              </label>
              <span className="w-auto col-auto position-relative">
                <ValidatedField
                  name={
                    revisors_handling_13
                      .revisors_handling_13_antal_transaktioner_udvalgt_som_stikproeve
                      .id
                  }
                  additionalClasses="w-100"
                  placeholder="0"
                  touched={
                    touched.revisors_handling_13_antal_transaktioner_udvalgt_som_stikproeve
                  }
                  error={
                    errors.revisors_handling_13_antal_transaktioner_udvalgt_som_stikproeve
                  }
                />
              </span>
            </div>
          </div>
          <div className="vstack gap-3" role="group">
            <RadioCard
              name={revisors_handling_13.revisors_handling_13_question.id}
              id={
                revisors_handling_13.revisors_handling_13_question
                  .revisors_handling_13_question_alt_1.value
              }
              value={
                revisors_handling_13.revisors_handling_13_question
                  .revisors_handling_13_question_alt_1.value
              }
              text={
                revisors_handling_13.revisors_handling_13_question
                  .revisors_handling_13_question_alt_1.label
              }
            ></RadioCard>
            <RadioCard
              name={revisors_handling_13.revisors_handling_13_question.id}
              id={
                revisors_handling_13.revisors_handling_13_question
                  .revisors_handling_13_question_alt_2.value
              }
              value={
                revisors_handling_13.revisors_handling_13_question
                  .revisors_handling_13_question_alt_2.value
              }
              text={
                revisors_handling_13.revisors_handling_13_question
                  .revisors_handling_13_question_alt_2.label
              }
            >
              <label className="mb-2">
                {
                  revisors_handling_13
                    .revisors_handling_13_question_alt_2_uddybning_table.label
                }
              </label>

              <FieldArray
                name={
                  revisors_handling_13
                    .revisors_handling_13_question_alt_2_uddybning_table.id
                }
                render={(arrayHelpers: any) => {
                  return (
                    <>
                      <div className="vstack gap-3">
                        {values.revisors_handling_13_question_alt_2_uddybning_table.map(
                          (row, index) => {
                            return (
                              <div
                                className="c-grid-card c-grid-card--col-5"
                                key={row.id ?? index}
                              >
                                <div className="d-flex align-items-center justify-content-between ps-2">
                                  <TableNumbers marginTop={0}>
                                    {(index + 1).toString()}
                                  </TableNumbers>
                                  <button
                                    className="btn btn-circle"
                                    type="button"
                                    aria-label="Fjern række"
                                    title="Fjern række"
                                    onClick={() => {
                                      arrayHelpers.remove(index);
                                    }}
                                  >
                                    <IconDelete />
                                  </button>
                                </div>
                                <div className="d-grid">
                                  <FieldWithLabel
                                    error={
                                      errors.revisors_handling_13_question_alt_2_uddybning_table &&
                                      isArray(
                                        errors.revisors_handling_13_question_alt_2_uddybning_table,
                                      ) &&
                                      errors
                                        .revisors_handling_13_question_alt_2_uddybning_table[
                                        index
                                      ] &&
                                      (
                                        errors
                                          .revisors_handling_13_question_alt_2_uddybning_table[
                                          index
                                        ] as any
                                      )
                                        .revisors_handling_13_question_alt_2_uddybning_table_column_dato
                                    }
                                    touched={
                                      touched.revisors_handling_13_question_alt_2_uddybning_table &&
                                      isArray(
                                        touched.revisors_handling_13_question_alt_2_uddybning_table,
                                      ) &&
                                      touched
                                        .revisors_handling_13_question_alt_2_uddybning_table[
                                        index
                                      ] &&
                                      (
                                        touched
                                          .revisors_handling_13_question_alt_2_uddybning_table[
                                          index
                                        ] as any
                                      )
                                        .revisors_handling_13_question_alt_2_uddybning_table_column_dato
                                    }
                                    fieldId={`${revisors_handling_13.revisors_handling_13_question_alt_2_uddybning_table.revisors_handling_13_question_alt_2_uddybning_table_column_dato.id}-${index}`}
                                    fieldName={`revisors_handling_13_question_alt_2_uddybning_table[${index}].revisors_handling_13_question_alt_2_uddybning_table_column_dato`}
                                    fieldType="date"
                                    label={
                                      revisors_handling_13
                                        .revisors_handling_13_question_alt_2_uddybning_table
                                        .revisors_handling_13_question_alt_2_uddybning_table_column_dato
                                        .label
                                    }
                                  />
                                  <FieldWithLabel
                                    fieldId={`${revisors_handling_13.revisors_handling_13_question_alt_2_uddybning_table.revisors_handling_13_question_alt_2_uddybning_table_column_beloeb.id}-${index}`}
                                    fieldName={`revisors_handling_13_question_alt_2_uddybning_table[${index}].revisors_handling_13_question_alt_2_uddybning_table_column_beloeb`}
                                    fieldType="text"
                                    label={
                                      revisors_handling_13
                                        .revisors_handling_13_question_alt_2_uddybning_table
                                        .revisors_handling_13_question_alt_2_uddybning_table_column_beloeb
                                        .label
                                    }
                                    error={
                                      errors.revisors_handling_13_question_alt_2_uddybning_table &&
                                      isArray(
                                        errors.revisors_handling_13_question_alt_2_uddybning_table,
                                      ) &&
                                      errors
                                        .revisors_handling_13_question_alt_2_uddybning_table[
                                        index
                                      ] &&
                                      (
                                        errors
                                          .revisors_handling_13_question_alt_2_uddybning_table[
                                          index
                                        ] as any
                                      )
                                        .revisors_handling_13_question_alt_2_uddybning_table_column_beloeb
                                    }
                                    touched={
                                      touched.revisors_handling_13_question_alt_2_uddybning_table &&
                                      isArray(
                                        touched.revisors_handling_13_question_alt_2_uddybning_table,
                                      ) &&
                                      touched
                                        .revisors_handling_13_question_alt_2_uddybning_table[
                                        index
                                      ] &&
                                      (
                                        touched
                                          .revisors_handling_13_question_alt_2_uddybning_table[
                                          index
                                        ] as any
                                      )
                                        .revisors_handling_13_question_alt_2_uddybning_table_column_beloeb
                                    }
                                  />
                                  <FieldWithLabel
                                    fieldId={`${revisors_handling_13.revisors_handling_13_question_alt_2_uddybning_table.revisors_handling_13_question_alt_2_uddybning_table_column_bilagsnummer.id}-${index}`}
                                    fieldName={`revisors_handling_13_question_alt_2_uddybning_table[${index}].revisors_handling_13_question_alt_2_uddybning_table_column_bilagsnummer`}
                                    fieldType="text"
                                    label={
                                      revisors_handling_13
                                        .revisors_handling_13_question_alt_2_uddybning_table
                                        .revisors_handling_13_question_alt_2_uddybning_table_column_bilagsnummer
                                        .label
                                    }
                                    error={
                                      errors.revisors_handling_13_question_alt_2_uddybning_table &&
                                      isArray(
                                        errors.revisors_handling_13_question_alt_2_uddybning_table,
                                      ) &&
                                      errors
                                        .revisors_handling_13_question_alt_2_uddybning_table[
                                        index
                                      ] &&
                                      (
                                        errors
                                          .revisors_handling_13_question_alt_2_uddybning_table[
                                          index
                                        ] as any
                                      )
                                        .revisors_handling_13_question_alt_2_uddybning_table_column_bilagsnummer
                                    }
                                    touched={
                                      touched.revisors_handling_13_question_alt_2_uddybning_table &&
                                      isArray(
                                        touched.revisors_handling_13_question_alt_2_uddybning_table,
                                      ) &&
                                      touched
                                        .revisors_handling_13_question_alt_2_uddybning_table[
                                        index
                                      ] &&
                                      (
                                        touched
                                          .revisors_handling_13_question_alt_2_uddybning_table[
                                          index
                                        ] as any
                                      )
                                        .revisors_handling_13_question_alt_2_uddybning_table_column_bilagsnummer
                                    }
                                  />
                                  <FieldWithLabel
                                    className="span-3"
                                    textArea
                                    fieldId={`${revisors_handling_13.revisors_handling_13_question_alt_2_uddybning_table.revisors_handling_13_question_alt_2_uddybning_table_column_begrundelse.id}-${index}`}
                                    fieldName={`revisors_handling_13_question_alt_2_uddybning_table[${index}].revisors_handling_13_question_alt_2_uddybning_table_column_begrundelse`}
                                    fieldType="text"
                                    label={
                                      revisors_handling_13
                                        .revisors_handling_13_question_alt_2_uddybning_table
                                        .revisors_handling_13_question_alt_2_uddybning_table_column_begrundelse
                                        .label
                                    }
                                    error={
                                      errors.revisors_handling_13_question_alt_2_uddybning_table &&
                                      isArray(
                                        errors.revisors_handling_13_question_alt_2_uddybning_table,
                                      ) &&
                                      errors
                                        .revisors_handling_13_question_alt_2_uddybning_table[
                                        index
                                      ] &&
                                      (
                                        errors
                                          .revisors_handling_13_question_alt_2_uddybning_table[
                                          index
                                        ] as any
                                      )
                                        .revisors_handling_13_question_alt_2_uddybning_table_column_begrundelse
                                    }
                                    touched={
                                      touched.revisors_handling_13_question_alt_2_uddybning_table &&
                                      isArray(
                                        touched.revisors_handling_13_question_alt_2_uddybning_table,
                                      ) &&
                                      touched
                                        .revisors_handling_13_question_alt_2_uddybning_table[
                                        index
                                      ] &&
                                      (
                                        touched
                                          .revisors_handling_13_question_alt_2_uddybning_table[
                                          index
                                        ] as any
                                      )
                                        .revisors_handling_13_question_alt_2_uddybning_table_column_begrundelse
                                    }
                                  />
                                </div>
                              </div>
                            );
                          },
                        )}
                        <button
                          className="btn btn-light w-100 small"
                          type="button"
                          onClick={() => {
                            arrayHelpers.push({
                              id: guid(),
                              revisors_handling_13_question_alt_2_uddybning_table_column_begrundelse:
                                undefined,
                              revisors_handling_13_question_alt_2_uddybning_table_column_beloeb:
                                undefined,
                              revisors_handling_13_question_alt_2_uddybning_table_column_bilagsnummer:
                                undefined,
                              revisors_handling_13_question_alt_2_uddybning_table_column_dato:
                                undefined,
                            });
                          }}
                        >
                          Tilføj flere
                        </button>
                      </div>
                    </>
                  );
                }}
              />
            </RadioCard>
          </div>
        </fieldset>
      </AccordionBody>
    </AccordionItem>
  );
}
